import { CarPdfViewer } from "@app/components/PdfViewer";
import { useSearchParams } from "react-router-dom";
import { AssetClassLoadType } from "@app/features/assets/useAssetClasses";
import { CarPdfDocument } from "@app/components/PdfDocument";
import { CarPdfPage, defaultClientPageSize } from "@app/components/PdfPage";
import { useUser } from "@app/pages/settings/useUser";
import { assetClassAnalysisPages } from "@app/const/route.const";
import { SummaryPdfChart } from "./SummaryPdfChart";
import { SummaryPdfTable } from "./SummaryPdfTable";
import { useAssetClassGroupSelector } from "@app/hooks/useAssetClassGroupSelector";
import {
  CarAssetClassAnalysisItemKey,
  useAssetClassSummaryStat,
} from "../useAssetClassSummaryStat";
import { AssetClassAnalysisTabId } from "../AssetClassAnalysisSummary";

export const SUMMARY_CHART_HEIGHT = 280;

export const PdfSummaryReportPage = () => {
  const [searchParams] = useSearchParams();
  const { assetClassGroupId, isReal, pageId, xStatId, yStatId } =
    assetClassAnalysisPages.getPdfSummaryReportParams(searchParams);

  const assetClassGroupSelector = useAssetClassGroupSelector(assetClassGroupId);

  const data = useAssetClassSummaryStat({
    type: AssetClassLoadType.byLatestSimulationJob,
    filterByUsableInPortfolios: true,
  });

  const rows = data.acSummaryItems.filter((i) =>
    assetClassGroupSelector.isAssetClassInGroup(i.level4Id),
  );

  const user = useUser();

  const title = `Asset Class Analysis - Summary`;
  const footer = "Asset Class Analysis";

  return (
    <CarPdfViewer
      isLoading={
        user.isLoading || assetClassGroupSelector.isLoading || data.isLoading
      }
    >
      <CarPdfDocument title={title} author={user.userFullName}>
        {
          <CarPdfPage
            reportTitle="Summary"
            sectionTitle="Historical Analysis"
            footer={footer}
          >
            <SummaryPdfChart
              style={{ marginTop: 16 }}
              width={defaultClientPageSize.width}
              height={SUMMARY_CHART_HEIGHT}
              items={rows}
              xStatId={xStatId as CarAssetClassAnalysisItemKey}
              yStatId={yStatId as CarAssetClassAnalysisItemKey}
              isWhiteContext={false}
            />
            <SummaryPdfTable
              style={{ marginTop: 30 }}
              rows={rows}
              isReal={isReal}
              pageId={pageId as AssetClassAnalysisTabId}
            />
          </CarPdfPage>
        }
      </CarPdfDocument>
    </CarPdfViewer>
  );
};
